import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [createPersistedState({
		storage: window.sessionStorage
	   })],
	state: {
		lang: localStorage.localeLanguage ? localStorage.localeLanguage : _DEFAULT_LANGUAGE_,
		token: sessionStorage.token ? sessionStorage.token : '',
		routerStore: sessionStorage.routerStore ? JSON.parse(sessionStorage.routerStore) : {},
		countdownStatus: {
			time: 60,
			disabled: false,
			txt: ''
		},
		userInfo:{}
	},

	mutations: {
		logout(state) {
			state.token = ''
			state.routerStore = {}
			state.userInfo = {}
			state.lang = ''
			sessionStorage.clear()
			
		},
		setToken(state, token) {
			state.token = token
			sessionStorage.setItem('token', state.token)
		},
		storeParams(state, params) {
			state.routerStore[params.name] = Object.assign({}, params)
			sessionStorage.setItem('routerStore', JSON.stringify(state.routerStore))
		},
		setParam(state, params) {
			if (state.routerStore[params.name]) {
				state.routerStore[params.name][params.prop] = params.value
				sessionStorage.setItem('routerStore', JSON.stringify(state.routerStore))
			}
		},
		setUserInfo(state, userInfo){
			state.userInfo = userInfo
			sessionStorage.setItem('idCheckResultStatus',userInfo.idCheckResultStatus)
		}
	}
})
